import {useCallback} from "react";
import {useBeforeUnload} from "react-router-dom";

/**
 * Asks the browser to confirm leaving while `active` (kitecorp/transferify-ui#1301): the page carries what
 * would be lost, a hosted upload in progress or an unfinished delivery. The browser shows its own dialog
 * and wording; a page can only ask for it.
 */
export function useBeforeUnloadWarning(active: boolean): void {
	useBeforeUnload(useCallback(event => {
		if (!active) return;
		event.preventDefault();
		// Legacy assignment remains necessary for browsers that do not honor preventDefault alone.
		event.returnValue = true;
	}, [active]), {capture: true});
}
